import { Component, AfterViewInit, ViewChild, inject, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { OfferService } from '../../../services/offer.service';
import { Router } from '@angular/router';
import { Division } from '../../../models/division';
import { Area } from '../../../models/area';
import { FilterOffer } from '../../../models/filters/filter-offer';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { findAreasCatalogAct, findDivisionsCatalogAct } from '../../../store/catalog-offer/catalog-offer.actions';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-offers',
  standalone: false,
  templateUrl: './offers.component.html',
  styleUrl: './offers.component.css'
})

export class OffersComponent implements AfterViewInit{

  @ViewChild(TableComponent) offersTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[
      {columnName:'Folio',columnValue:'folio'},
      {columnName:'Nombre',columnValue:'fullName'},
      {columnName:'Tipo Oferta',columnValue:'typeOfferDes'},
      {columnName:'Estado Oferta',columnValue:'statusDescription'},
      {columnName:'Firmas',columnValue:'offerSignatures', signatures: true}
    ],
    dataSource: [],
    editButton:true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  divisions: Division[] = [];
  areas: Area[] = [];
  filterOffer: FilterOffer = new FilterOffer;
  advancedSearch: boolean = true;

  private offerService = inject(OfferService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngAfterViewInit() {
  }
  ngOnInit(): void {
    this.filterOffer = new FilterOffer();
    this.filterOffer.ac = 1;
    this.searchOffersPaginator();

    this.catalogOfferStore.dispatch(findDivisionsCatalogAct());
    this.catalogOfferStore.dispatch(findAreasCatalogAct());
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchOffersPaginator();
  }

  editEvent(event: any){
    this.loading = true;
    this.router.navigate(['/offers/edit', event.id]);
  }

  searchOffersPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchOffersPaginator();
  }

  searchOffersPaginator(){
    this.loading = true;

    this.offerService.findAllPageableOffer(this.filterOffer, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.offersTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    /*if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }*/
  }

  constructor(
    private catalogOfferStore: Store<{catalogOfferRdc: any}>
  ){
    this.catalogOfferStore.pipe(
      select('catalogOfferRdc'),
      map(state => ({
        divisions: state.divisions,
        areas: state.areas,
      })),
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ divisions, areas}) => {
      this.divisions = divisions;
      this.areas = areas;
    });
  }

}
